// E.164-Normalisierung für DE/CH Nummern
// "0176 12345678" → "+4917612345678"
// "+49 (0) 176 12345678" → "+4917612345678"
// "+41 79 123 45 67" → "+41791234567"
// "0041 79 123 45 67" → "+41791234567"
export const normalizePhone = (phone) => {
  if (!phone) return ''
  let p = String(phone).replace(/[\s\-()]/g, '')
  p = p.replace(/^\+49\(?0\)?/i, '+49').replace(/^\+41\(?0\)?/i, '+41')
  if (p.startsWith('00')) p = '+' + p.slice(2)
  if (p.startsWith('0')) p = '+49' + p.slice(1)
  return p
}

export const pad = n => String(n).padStart(2, '0')

export function getNowTime() {
  const now = new Date()
  return `${pad(now.getHours())}:${pad(now.getMinutes())}`
}

export function formatTime(time, timeEnd) {
  if (!time || time === 'asap') return 'Schnellstmöglich'
  try {
    const d = new Date(time)
    const today = new Date()
    const isToday = d.toDateString() === today.toDateString()
    const datePrefix = isToday ? '' : d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }) + '\n'
    const start = d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
    if (timeEnd) {
      const end = new Date(timeEnd).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
      return `${datePrefix}${start} – ${end} Uhr`
    }
    return `${datePrefix}${start} Uhr`
  } catch { return time }
}

export function formatDate(ts) {
  if (!ts) return '—'
  const d = ts.toDate ? ts.toDate() : new Date(ts)
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function getDateParts(ts) {
  if (!ts) return { day: '—', month: '—' }
  const d = ts.toDate ? ts.toDate() : new Date(ts)
  return {
    day: d.toLocaleDateString('de-DE', { day: '2-digit' }),
    month: d.toLocaleDateString('de-DE', { month: 'short' }).toUpperCase(),
  }
}

export function formatAddress(addr) {
  if (!addr) return ''
  const road = [addr.road, addr.house_number].filter(Boolean).join(' ')
  const city = addr.city || addr.town || addr.village || addr.municipality || ''
  const postcode = addr.postcode || ''
  return [road, [postcode, city].filter(Boolean).join(' ')].filter(Boolean).join(', ')
}
